import React from "react";
import classNames from "classnames";
import RulesInfo from "../RuleInfo";
import {useHistory} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {PATHS} from "../../../route-dictionary";
import {withErrorBoundary} from "../../ErrorBoundary";
import useCheckIdParams from "../../../pages/rules/hooks/useCheckIdParams";
import {CButton, CCard, CCardBody, CCardTitle} from "@coreui/react";
import "./RulesCard.scss";
import NoRulesText from "../NoRulesText";

const RulesCard = (props) => {
  const {
    rules,
    showEditButton,
    showDeleteButton,
    showRuleSwitcher,
    showRuleAddButton,
    updateStates,
    members,
    telegramChats,
    noRulesText,
    updateRule,
    deleteRule,
    className
  } = props;

  const {t} = useTranslation();
  const history = useHistory();
  const {isChecksRulePage, checkId} = useCheckIdParams();

  return (
    <CCard className={classNames("RulesCard", className)}>
      <CCardBody>
        <CCardTitle className="RulesCard-header">
          <span className="RulesCard-header__text">
            {t("card.title.rules", "Rules")}
          </span>
          {
            showRuleAddButton &&
            <CButton
              color="info"
              variant="outline"
              className="RulesCard-header__add-button"
              onClick={() => history.push(
                isChecksRulePage ?
                  PATHS.CHECKS.getChecksRuleAddPath(checkId) :
                  PATHS.RULES.ADD
              )}
            >
              {t("button.addRule", "Add Rule")}
            </CButton>
          }
        </CCardTitle>
        {rules.length === 0
          ? <p>{noRulesText}</p>
          : <div className="RulesCard__rules">
            {rules.map((rule) => (
              <div className="RulesCard__rule" key={`rule_${rule.id}`}>
                <RulesInfo
                  rule={rule}
                  members={members}
                  telegramChats={telegramChats}
                  updateStates={updateStates}
                  showRuleSwitcher={showRuleSwitcher}
                  showEditButton={showEditButton}
                  showDeleteButton={showDeleteButton}
                  updateRule={updateRule}
                  deleteRule={deleteRule}
                />
              </div>
            ))}
          </div>
        }
      </CCardBody>
    </CCard>
  );
};

RulesCard.defaultProps = {
  rules: [],
  noRulesText: <NoRulesText/>
};

export default withErrorBoundary(RulesCard);